<script setup lang="ts">
import { Product } from '@/types/api/api-v3/product'

/* Components */
import ProductCardTag from '@/components/Product/ProductCard/ProductCardTag.vue'

const MIN_RATING = 4

// TODO: Размер lg удалить когда детальная страница товара будет с новым дизайном
type Size = 'sm' | 'md' | 'lg'

type Props = {
  product: Product
  size: Size
}

const props = defineProps<Props>()

const componentClasses = computed(() => {
  return [`product-card-rating-tag--size-${props.size}`]
})

const isVisible = computed(() => {
  return props.product?.rating && props.product?.rating >= MIN_RATING
})
</script>

<template>
  <product-card-tag
    v-if="isVisible"
    class="product-card-rating-tag"
    :class="componentClasses"
    :size="size"
    background-color="var(--ui-dark-grey)"
  >
    <nuxt-img
      src="/product/rating-star.svg"
      alt="Рейтинг"
      class="product-card-rating-tag__icon"
    />
    {{ product?.rating }}
  </product-card-tag>
</template>

<style lang="scss" scoped>
.product-card-rating-tag {
  color: var(--ui-white);

  &__icon {
    width: var(--rating-icon-size);
    height: var(--rating-icon-size);
  }
}

.product-card-rating-tag--size-sm {
  --rating-icon-size: 10px;

  @include media('>=desktop-mini') {
    --rating-icon-size: 14px;
  }
}

.product-card-rating-tag--size-md,
.product-card-rating-tag--size-lg {
  --rating-icon-size: 16px;
}
</style>
